import React from "react";

export default function Locate() {

  const mapUrl =
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7004.165748472375!2d77.3673534556453!3d28.627278184318282!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5f6bf0e729b%3A0x4c68e44d9e70a67f!2sI-Thum%20Tower%20-%20office%20space%20in%20IThum%20Noida%20Sector%2062!5e0!3m2!1sen!2sin!4v1751014402395!5m2!1sen!2sin";

  return (
    <div className="max-w-7xl mx-auto">
      <div className="bg-light rounded-lg overflow-hidden">
        <div className="relative">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="min-h-screen flex justify-center items-center mt-5 mx-3">
              <div className="d-flex justify-content-center align-items-center mb-5 w-100">
                <div className="p-4 bg-white rounded container">
                  <h2 className="h4 fw-bold text-dark mb-4 text-center">
                    Visit Our Office
                  </h2>

                  <div className="text-secondary text-center">
                    <p className="mb-2">
                      <strong>Address:</strong> I-Thum Tower, B-218, Noida
                      Sector 62, Uttar Pradesh
                    </p>

                    <p className="mb-2">
                      <strong>Hours:</strong> Mon–Sat: 9:30 AM – 6:30 PM
                    </p>

                    <p className="mb-0">
                      <strong>Contact:</strong> +91 9898800754
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Map Section */}
            <div
              className="container p-0 position-relative"
              style={{ minHeight: "400px" }}
            >

              <iframe
                src={mapUrl}
                width="100%"
                height="100%"
                className="w-full h-full"
                style={{ border: 0, minHeight: "400px" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="I-Thum Tower Location Map"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
